import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "q-pa-md" };
const _hoisted_2 = { class: "text-h4 text-bold text-green-7" };
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = { class: "q-pa-md" };
const _hoisted_5 = { class: "q-mb-lg entry-check-table" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_breadcrumb_list = _resolveComponent("breadcrumb-list");
    const _component_q_card_section = _resolveComponent("q-card-section");
    const _component_q_separator = _resolveComponent("q-separator");
    const _component_q_badge = _resolveComponent("q-badge");
    const _component_q_icon = _resolveComponent("q-icon");
    const _component_q_input = _resolveComponent("q-input");
    const _component_q_btn = _resolveComponent("q-btn");
    const _component_q_card_actions = _resolveComponent("q-card-actions");
    const _component_q_card = _resolveComponent("q-card");
    const _component_q_page = _resolveComponent("q-page");
    return (_openBlock(), _createBlock(_component_q_page, { class: "col column no-wrap" }, {
        default: _withCtx(() => [
            _createVNode(_component_breadcrumb_list, {
                breadCrumbs: [
                    { itemId: _ctx.PageID.top },
                    { itemId: _ctx.PageID.keiyaku },
                    { itemId: _ctx.PageID.passwordChange }
                ]
            }, null, 8, ["breadCrumbs"]),
            _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_q_card, null, {
                    default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "bg-white" }, {
                            default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.pageName), 1)
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_separator),
                        _createVNode(_component_q_card_section, null, {
                            default: _withCtx(() => [
                                _createElementVNode("div", {
                                    class: "q-pa-md",
                                    innerHTML: _ctx.changeHtml
                                }, null, 8, _hoisted_3),
                                _createElementVNode("div", _hoisted_4, [
                                    _cache[13] || (_cache[13] = _createElementVNode("div", { class: "table-caption" }, "新しいパスワードを設定してください。", -1)),
                                    _createElementVNode("table", _hoisted_5, [
                                        _createElementVNode("tbody", null, [
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, [
                                                    _cache[8] || (_cache[8] = _createTextVNode("旧パスワード ", -1)),
                                                    _createVNode(_component_q_badge, {
                                                        color: "red-9",
                                                        align: "middle"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                                                _createTextVNode("必須", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_q_input, {
                                                        modelValue: _ctx.data.current,
                                                        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((_ctx.data.current) = $event)),
                                                        color: "positive",
                                                        type: _ctx.data.isPwd ? 'password' : 'text',
                                                        outlined: "",
                                                        "bottom-slots": "",
                                                        dense: "",
                                                        error: _ctx.valid.current.error,
                                                        "error-message": _ctx.valid.current.message
                                                    }, {
                                                        append: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                                name: _ctx.data.isPwd ? 'visibility_off' : 'visibility',
                                                                class: "cursor-pointer",
                                                                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.data.isPwd = !_ctx.data.isPwd))
                                                            }, null, 8, ["name"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue", "type", "error", "error-message"])
                                                ])
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, [
                                                    _cache[10] || (_cache[10] = _createTextVNode("新パスワード ", -1)),
                                                    _createVNode(_component_q_badge, {
                                                        color: "red-9",
                                                        align: "middle"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                                _createTextVNode("必須", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_q_input, {
                                                        modelValue: _ctx.data.new,
                                                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.data.new) = $event)),
                                                        color: "positive",
                                                        type: _ctx.data.isPwd ? 'password' : 'text',
                                                        outlined: "",
                                                        "bottom-slots": "",
                                                        dense: "",
                                                        error: _ctx.valid.new.error,
                                                        "error-message": _ctx.valid.new.message
                                                    }, {
                                                        append: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                                name: _ctx.data.isPwd ? 'visibility_off' : 'visibility',
                                                                class: "cursor-pointer",
                                                                onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.data.isPwd = !_ctx.data.isPwd))
                                                            }, null, 8, ["name"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue", "type", "error", "error-message"])
                                                ])
                                            ]),
                                            _createElementVNode("tr", null, [
                                                _createElementVNode("th", null, [
                                                    _cache[12] || (_cache[12] = _createTextVNode("新パスワード(確認) ", -1)),
                                                    _createVNode(_component_q_badge, {
                                                        color: "red-9",
                                                        align: "middle"
                                                    }, {
                                                        default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                                                _createTextVNode("必須", -1)
                                                            ]))]),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("td", null, [
                                                    _createVNode(_component_q_input, {
                                                        modelValue: _ctx.data.confirm,
                                                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.data.confirm) = $event)),
                                                        color: "positive",
                                                        type: _ctx.data.isPwd ? 'password' : 'text',
                                                        outlined: "",
                                                        "bottom-slots": "",
                                                        dense: "",
                                                        error: _ctx.valid.confirm.error,
                                                        "error-message": _ctx.valid.confirm.message
                                                    }, {
                                                        append: _withCtx(() => [
                                                            _createVNode(_component_q_icon, {
                                                                name: _ctx.data.isPwd ? 'visibility_off' : 'visibility',
                                                                class: "cursor-pointer",
                                                                onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.data.isPwd = !_ctx.data.isPwd))
                                                            }, null, 8, ["name"])
                                                        ]),
                                                        _: 1
                                                    }, 8, ["modelValue", "type", "error", "error-message"])
                                                ])
                                            ])
                                        ])
                                    ])
                                ])
                            ]),
                            _: 1
                        }),
                        _createVNode(_component_q_card_actions, {
                            class: "q-pb-lg",
                            align: "center"
                        }, {
                            default: _withCtx(() => [
                                _createVNode(_component_q_btn, {
                                    label: "戻る",
                                    class: "btn-route col-5 col-md-3",
                                    color: "grey-8",
                                    icon: "navigate_before",
                                    onClick: _cache[6] || (_cache[6] = ($event) => (_ctx.$router.back()))
                                }),
                                _createVNode(_component_q_btn, {
                                    label: "確定",
                                    class: "btn-route col-5 col-md-3",
                                    color: "green-7",
                                    "icon-right": "navigate_next",
                                    onClick: _ctx.submit
                                }, null, 8, ["onClick"])
                            ]),
                            _: 1
                        })
                    ]),
                    _: 1
                })
            ])
        ]),
        _: 1
    }));
}
